export default __webpack_public_path__ + "static/media/highlight-1-new.24c43346.jpg";